// JavaScript Document
$(function () {
    /*------------------
      scroll
    --------------------*/
    var speed = 400;
    $(document).on("click", 'a[href^="#"]', function () {
        var href = $(this).attr("href");
        var target = $(href === "#" || href === "#" ? "html" : href);
        var position = target.offset().top;
        $("html, body").animate({ scrollTop: position }, speed, "swing");
        return false;
    });

    $(".js-open").click(function () {
        $("body").addClass("no_scroll"); // 背景固定させるクラス付与
        $("#overlay, .modal-window").fadeIn();
    });
    // オーバーレイクリックでもモーダルを閉じるように
    $(".js-close , #overlay").click(function () {
        $("body").removeClass("no_scroll"); // 背景固定させるクラス削除
        $("#overlay, .modal-window").fadeOut();
    });

    /*------------------
      slick
    --------------------*/

    if ($(".product-variation").length > 0) {
        $(".product-variation").slick({
            autoplay: false,
            arrows: true,
            prevArrow: '<img src="./assets/images/arrow_prev.svg" class="slide-arrow prev-arrow">',
            nextArrow: '<img src="./assets/images/arrow_next.svg" class="slide-arrow next-arrow">',
            dots: true,
            infinite: true,
            speed: 300,
            slidesToShow: 3,
            slidesToScroll: 3,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    },
                },
            ],
        });
    }
});
